// extracted by mini-css-extract-plugin
export default {"photoContainer":"ProtocolCreationPhotos_photoContainer__04yL7","photoItem":"ProtocolCreationPhotos_photoItem__vHqpc"};